import apiFetch from '@wordpress/api-fetch'

const mkReduxActionApiRequest = ({
  apiFetchArgs,
  types,
  dispatch,
  previousAbortController,
  extraActionProperties = {},
}) => {
  if (previousAbortController) {
    previousAbortController.abort()
  }

  let abortController
  let signal
  if (types.aborted) {
    abortController = new window.AbortController()
    signal = abortController.signal
    signal.addEventListener('abort', () => {
      dispatch({ type: types.aborted })
    })
  }

  dispatch({
    ...extraActionProperties,
    type: types.initial,
    abortController,
  })

  return apiFetch({ ...apiFetchArgs, signal })
    .then(data => {
      dispatch({
        ...extraActionProperties,
        payload: data,
        type: types.success,
      })
      return data
    })
    .catch(error => {
      if (error.name !== 'AbortError') {
        dispatch({
          payload: {
            error: error,
          },
          type: types.failure,
        })
        throw error
      }
    })
}

export default mkReduxActionApiRequest
